import React, { useMemo } from 'react';
import { Grid, Typography, Box } from '@material-ui/core';
import styles from './styles';

interface IAdvantage {
    title: string
    icon: string
    description: string
}

const clearAligners3x = `${process.env.GATSBY_IMAGES}home/advantageIcons/clear-aligners@3x.png`;
const stepPricing3x = `${process.env.GATSBY_IMAGES}home/advantageIcons/step-pricing@3x.png`;
const perfectFit3x = `${process.env.GATSBY_IMAGES}home/advantageIcons/perfect-fit@3x.png`;
const verification3x = `${process.env.GATSBY_IMAGES}home/advantageIcons/verification@3x.png`;

export const Advantages = () => {
    const classes = styles()

    const advantages: IAdvantage[] = [
        {
            title: 'The Difference is Clear',
            icon: clearAligners3x,
            description:
                'Orthosnap creates perfectly clear aligners with no striations. Other companies use 3D printing, which leads to opaque striations and increased measurement errors. Orthosnap aligners are truly clear. Your patients will see the difference and you\'ll see the results.',
        },
        {
            title: 'No Upfront Costs',
            icon: stepPricing3x,
            description:
                'Unlike other dental aligner companies which expect thousands upfront, Orthosnap offers “Step Pricing” - only pay for the aligners you use. Our step pricing model (instead of tier pricing) keeps cost down for you and your patients. This means a profitable treatment and better outcomes for your patients.',
        },
        {
            title: 'Close for Comfort',
            icon: perfectFit3x,
            description:
                'Our patented manufacturing process ensures your patients get a perfect fit every time. Unlike 3D printed aligners, the Orthosnap superior fit allows for effective teeth alignment. The Orthosnap precision aligner delivers near invisibility and perfect smiles.',
        },
        {
            title: 'Key to Compliance',
            icon: verification3x,
            description:
                'The unique Orthosnap Verification Key™ is a patient compliance step in the aligner treatment, giving the doctor control throughout the process. Every 8th step comes with a Verification Key™ aligner. This appliance is made of thicker material and is only to be fitted in the doctor’s office, to verify the treatment is on track.',
        },
    ]

    const renderedAdvantages = useMemo(() => {
        return advantages.map((advantage) => {
            const { icon, title, description } = advantage
            return (
                <Grid key={title} item lg={6} md={6} className={classes.item}>
                    <Box
                        style={{
                            background: `url(${icon}) no-repeat`,
                            backgroundSize: 'contain',
                        }}
                        className={classes.iconWrapper}
                    />

                    <Typography variant="subtitle2" className={classes.title}>
                        {title}
                    </Typography>
                    <Typography variant="body1" className={classes.description}>
                        {description}
                    </Typography>
                </Grid>
            )
        })
    }, [advantages])

    return (
        <Grid container justify="center" className={classes.wrapper}>
            {renderedAdvantages}
        </Grid>
    )
}

export default Advantages
